import {
  put,
  fork,
  call,
  take,
  takeEvery,
  takeLatest,
  all,
  select,
} from 'redux-saga/effects';
import app from '../../app';
import {
  resetOrderInfo,
  removeCart,
  catchError,
  loadOrderTrackCompletion,
  loadOrderListCompletion,
  loadWeappOrderListCompletion,
  loadOrderCompletion,
  loadStoreOrderListCompletion,
  loadStoreOrderCompletion,
  cancelOrderCompletion,
  removeOrderCompletion,
  refundOrderCompletion,
  loadOrder,
  refundCouponOrderCompletion,
  receiptOrderCompletion,
  preCreateOrderCompletion,
  createOrderCompletion,
  loadOrderSkuCompletion,
  editOrderSkuCommentCompletion,
  loadAgentProductOrderDetailCompletion,
  loadProduct,
} from '../../actions';
import { strLength } from '../../utils/string';

function* watchLoadOrderTrack() {
  yield takeEvery('LOAD_ORDER_TRACK', function*({ orderId }) {
    const options = {
      url: `/api/order/trace`,
      data: { orderId },
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadOrderTrackCompletion(orderId, result.error, result.data));
  });
}

function* watchLoadOrderList() {
  yield takeLatest('LOAD_ORDER_LIST', function*({ willReload }) {
    const { list, query } = yield select(state => state.mall.order.master);
    const tabDict = { all: 0, willpay: 1, didship: 2, willcomment: 3 };
    let start = 0;
    let tab = 0;

    if (!willReload && list) {
      start = list.length;
    }
    if (!query.keyword) {
      tab = tabDict[query.tab];
    }

    const options = {
      url: `/api/order/list?start=${start}&size=${
        query.size
      }&tab=${tab}&keyword=${encodeURIComponent(query.keyword)}`,
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      loadOrderListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

function* watchLoadStoreOrderList() {
  yield takeLatest('LOAD_STORE_ORDER_LIST', function*({ willReload }) {
    const { list, query } = yield select(state => state.mall.order.storeMaster);
    const tabDict = { all: -1, sale: 0, return: 1 };
    let start = 0;
    let tab = 0;

    if (!willReload && list) {
      start = list.length;
    }
    if (!query.keyword) {
      tab = tabDict[query.tab];
    }

    const options = {
      url: `/api/order/ljOrderList`,
      method: 'POST',
      data: {
        start: start,
        size: query.size,
        tab,
        keyword: query.keyword,
      },
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      loadStoreOrderListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

function* watchLoadWeappOrderList() {
  yield takeLatest('LOAD_WEAPP_ORDER_LIST', function*({ willReload }) {
    const { list, query } = yield select(state => state.mall.order.master);
    const tabDict = { all: 0, willpay: 1, didship: 2, willcomment: 3 };
    let start = 0;
    let tab = 0;

    if (!willReload && list) {
      start = list.length;
    }
    if (!query.keyword) {
      tab = tabDict[query.tab];
    }

    const options = {
      url: `/api/order/list?start=${start}&size=${
        query.size
      }&tab=${tab}&keyword=${encodeURIComponent(query.keyword)}`,
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      loadWeappOrderListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

function* watchLoadOrder() {
  yield takeEvery('LOAD_ORDER', function*({ orderId }) {
    const options = {
      url: `/api/order/${orderId}/detail`,
    };
    let result = yield call(app.httpFetch, options);

    if (!result.error && result.data) {
      const { orderType, orderStatus, orderId } = result.data;
      if (orderType === 4 && orderStatus !== 10 && orderStatus !== -11) {
        const ptResult = yield call(app.httpFetch, {
          url: `/api/pt/order/${orderId}`,
        });
        if (!ptResult.error) {
          result.data = {
            ...result.data,
            pt: ptResult.data,
          };
        }
      }
    }
    yield put(loadOrderCompletion(orderId, result.data, result.error));
  });
}

function* watchLoadStoreOrder() {
  yield takeEvery('LOAD_STORE_ORDER', function*({ billNo }) {
    const options = {
      url: `/api/order/ljOrderDetail`,
      method: 'POST',
      data: {
        billNo,
      },
    };
    let result = yield call(app.httpFetch, options);
    yield put(loadStoreOrderCompletion(billNo, result.data, result.error));
  });
}

function* watchCancelOrder() {
  while (true) {
    const { orderId } = yield take('CANCEL_ORDER');
    const options = {
      url: `/api/order/${orderId}/cancel`,
      method: 'POST',
    };
    const result = yield call(app.httpFetch, options);
    yield put(cancelOrderCompletion(orderId, result.data, result.error));
  }
}

function* watchRemoveOrder() {
  while (true) {
    const { orderId } = yield take('REMOVE_ORDER');
    const options = {
      url: `/api/order/${orderId}/delete`,
      method: 'POST',
    };
    const result = yield call(app.httpFetch, options);
    yield put(removeOrderCompletion(orderId, result.data, result.error));
  }
}

function* watchRefundOrder() {
  while (true) {
    const { orderId } = yield take('REFUND_ORDER');
    const options = {
      url: `/api/order/${orderId}/refund`,
      method: 'POST',
      parseData: json => {
        const { code, message, now, obj } = json;

        if (code < 0 && code != -1) {
          const error = new Error(message);
          error.code = code;
          throw error;
        }

        if (code == -1) {
          return { data: obj || {}, now, error: { code, message } };
        }

        return { data: obj || {}, now };
      },
    };
    const result = yield call(app.httpFetch, options);
    // console.log('----', result);
    yield put(refundOrderCompletion(orderId, result.data, result.error));

    if (!result.error) {
      yield put(loadOrder(orderId));
    }
  }
}

function* watchRefundCouponOrder() {
  while (true) {
    const { orderId } = yield take('REFUND_COUPON_ORDER');
    const options = {
      url: `/api/order/${orderId}/refund`,
      method: 'POST',
      parseData: json => {
        const { code, message, now, obj } = json;

        if (code < 0 && code != -1) {
          const error = new Error(message);
          error.code = code;
          throw error;
        }

        if (code == -1) {
          return { data: obj || {}, now, error: { code, message } };
        }

        return { data: obj || {}, now };
      },
    };
    const result = yield call(app.httpFetch, options);
    // console.log('----', result);
    yield put(refundOrderCompletion(orderId, result.data, result.error));
  }
}

function* watchReceiptOrder() {
  while (true) {
    const { orderId } = yield take('RECEIPT_ORDER');
    const options = {
      url: `/api/order/${orderId}/confirm`,
      method: 'POST',
    };
    const result = yield call(app.httpFetch, options);
    yield put(receiptOrderCompletion(orderId, result.data, result.error));
  }
}

function* watchPreCreateOrder() {
  yield takeEvery('PRE_CREATE_ORDER', function*({
    selectedList,
    giftList,
    groupId,
    isOverseaOrder,
    recoverData,
  }) {
    const products = yield select(state => state.mall.product.products);
    let orderType;

    if (selectedList.length <= 0 && giftList.length <= 0) {
      yield put(resetOrderInfo(isOverseaOrder));
      yield put(
        preCreateOrderCompletion(orderType, new Error('订单商品不能为空'))
      );
      return;
    }

    if (giftList.length > 0) {
      orderType = 0;
    } else if (selectedList.length > 1) {
      orderType = isOverseaOrder ? 6 : 0;
    } else {
      const code = selectedList[0].code;
      let product = products[code];

      if (!product) {
        yield put(loadProduct(code));
        const productResult = yield take('LOAD_PRODUCT_COMPLETION');
        product = productResult.data;
      }

      const { type } = product;

      if (type === 1) {
        orderType = 1;
      } else if (type === 3) {
        orderType = 2;
      } else if (type === 4) {
        orderType = 4;
      } else if (type === 6 || type === 7) {
        orderType = 6;
      } else if (type === 10) {
        orderType = 7;
      } else {
        orderType = 0;
      }
    }

    const orderSkuVos = selectedList.map(item => ({
      code: item.code,
      num: item.number,
    }));

    let url = '/api/order/preCreate';

    if (orderType === 2) {
      url = '/api/order/secKill/preCreate';
    }

    const options = {
      url,
      method: 'POST',
      data: {
        orderType,
        orderSkuVos,
        orderDiscountVo: {
          productCouponIds: giftList,
          groupId,
          cashCouponId: (recoverData && recoverData.cashId) || undefined,
        },
      },
    };
    const result = yield call(app.httpFetch, options);

    if (result.error) {
      yield put(preCreateOrderCompletion(orderType, result.error));
      return;
    }

    yield put(
      preCreateOrderCompletion(
        orderType,
        result.error,
        result.data,
        selectedList,
        giftList,
        groupId,
        recoverData
      )
    );
  });
}

function encodeCreateOrderKey(key) {
  return (
    key &&
    key
      .split('')
      .map((str, i) => {
        const charCode = str.charCodeAt();
        if (i <= 4) {
          if (charCode >= 54) {
            return String.fromCharCode(charCode + 19);
          }
        } else if (i > 4 && i <= 7) {
          return String.fromCharCode(charCode + 52);
        } else if (i > 7 && i <= 9) {
          if (charCode === '3') {
            return 'b';
          } else if (charCode === '8') {
            return 'm';
          }
        } else if (i > 12) {
          if (charCode <= 57) {
            return String.fromCharCode(charCode + 60);
          } else {
            return String.fromCharCode(charCode + (i % 15));
          }
        }

        return str;
      })
      .join('')
  );
}

function* watchCreateOrder() {
  yield takeEvery('CREATE_ORDER', function*({ isOverseaOrder }) {
    let stateKey = 'create';
    if (isOverseaOrder) {
      stateKey = 'overseaCreate';
    }

    const orderCreate = yield select(state => state.mall.order[stateKey]);

    const {
      orderType,
      addressId,
      groupId,
      selectedList,
      giftList: productCouponIds,
      cashId,
      postageId,
      idCardNo,
      didAgree,
      key,
      payType,
      needsDeleteFromCart,
      extra
    } = orderCreate;
    let error;

    if (!addressId) {
      if(extra.orderSkuVos && extra.orderSkuVos.length > 0 && extra.orderSkuVos[0].type !== 15){ // byTanj@20240530 需求：对于type=15的门店券商品，不需要选择地址
        error = new Error('请填写收货地址');
      }
    }

    if (isOverseaOrder) {
      if (idCardNo === '') {
        error = new Error('请填写收货人身份证信息');
      } else if (!didAgree) {
        error = new Error('购买全球购商品需同意《用户购买须知》');
      }
    }

    if (error) {
      yield put(catchError(error));
      yield put(createOrderCompletion(isOverseaOrder, error));
      return;
    }

    const wxClickId = yield call(app.getStorage, 'WX_CLICK_ID');

    const data = {
      addressId,
      orderType,
      orderDiscountVo: { productCouponIds, groupId },
      idCardNo,
      key: encodeCreateOrderKey(key),
    };

    data.orderSkuVos = selectedList.map(item => ({
      code: item.code,
      num: item.number,
    }));

    if (cashId) {
      data.orderDiscountVo.cashCouponId = cashId;
    }
    if (postageId) {
      data.orderDiscountVo.postageCouponId = postageId;
    }
    if (wxClickId) {
      data.adClickId = wxClickId;
      data.adUrl = 'http://www.qq.com';
    }

    const options = {
      url: '/api/order/create',
      method: 'POST',
      data,
      error_silent: true,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      createOrderCompletion(isOverseaOrder, result.error, result.data, payType)
    );

    if (result.error) {
      if (result.error.code !== -401) {
        yield put(catchError(result.error));
      }
      return;
    }

    if (needsDeleteFromCart) {
      if (isOverseaOrder) {
        yield put(removeCart(selectedList, 2));
      } else {
        yield put(removeCart(selectedList));
      }
    }

    /* const coupons = yield select(state => state.mall.coupon.coupons);
    const cashCoupon = coupons[cashId] || null;
    const postageCoupon = coupons[postageId] || null;
    const giftCoupons = productCouponIds.map(id => coupons[id]);

    const order = result.data;

    app.track.trackEvent('submitOrder', {
      order,
      cashCoupon,
      giftCoupons,
      postageCoupon,
    }); */
  });
}

function* watchLoadOrderSku() {
  yield takeEvery('LOAD_ORDER_SKU', function*({ orderSkuId }) {
    const options = {
      url: `/api/after/sku/${orderSkuId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadOrderSkuCompletion(orderSkuId, result.error, result.data));
  });
}

function* watchEditOrderSkuComment() {
  yield takeEvery('EDIT_ORDER_SKU_COMMENT', function*({ orderSkuId }) {
    const orderSkuCommentEdit = yield select(
      state => state.mall.order.orderSkuCommentEdit
    );
    const {
      input: { isAnony, content },
    } = orderSkuCommentEdit;

    let error;
    const submitContent = content.trim();
    if (!submitContent) {
      error = new Error('还没填写评价哦');
    }
    if (strLength(submitContent) > 150) {
      error = new Error('评价不能超过150字哦');
    }

    if (error) {
      yield put(catchError(error));
      yield put(editOrderSkuCommentCompletion(orderSkuId, error));
      return;
    }

    const options = {
      url: '/api/product/comment',
      method: 'POST',
      data: { orderSkuId, isAnony, text: submitContent },
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      editOrderSkuCommentCompletion(orderSkuId, result.error, result.data)
    );
  });
}

function* watchLoadAgentProductOrderDetail() {
  yield takeEvery('LOAD_AGENT_PRODUCT_ORDER_DETAIL', function*() {
    const options = {
      url: '/api/order/giftOrder/status',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadAgentProductOrderDetailCompletion(result.error, result.data));
  });
}

export default function* orderSaga() {
  yield all([
    fork(watchLoadOrderTrack),
    fork(watchLoadOrderList),
    fork(watchLoadStoreOrderList),
    fork(watchLoadWeappOrderList),
    fork(watchLoadOrder),
    fork(watchLoadStoreOrder),
    fork(watchCancelOrder),
    fork(watchRemoveOrder),
    fork(watchRefundOrder),
    fork(watchRefundCouponOrder),
    fork(watchReceiptOrder),
    fork(watchPreCreateOrder),
    fork(watchCreateOrder),
    fork(watchLoadOrderSku),
    fork(watchEditOrderSkuComment),
    fork(watchLoadAgentProductOrderDetail),
  ]);
}
